import { getRunEnv } from "@vromo/utils";

/** production vromo api base url for all endpoints */
export const prodBackend = process.env.REST_API || 'prod-api.spatula.io';

/** browser local storage key for Vromo session token*/
export const VromoSessionTokenKEY = 'sharedFleetToken';
/** browser local storage key for Tray session token*/
export const TraySessionTokenKEY = 'integrationSessionToken';

export const localServer = 'localhost:3000';

/** access tokens / api keys, for remote apis  */
export const secrets = {
    ipstack: 'https://api.ipstack.com/check?access_key=e1ba77ac610cb59592c6efd3332c1849',
    bugsnag: '504f90afb68781448d0acb6d96af752f',
    mapbox: 'pk.eyJ1IjoiZmxlZXRlbmciLCJhIjoiY2w4YmFuY2VzMHAycTNubnUwOThtcGJnaiJ9.CldqDZ8yWj2m1kWM30PLWg',
};

export const remoteApisUrls = () => {
    const urls = {
        integrations: {
            /**
             * @note previously  'https://271af402-bf27-49c6-bb2c-95979b70a060.trayapp.io' */
            listAll: 'https://integration-helpers.vromo.io/api/v2/integrations',
            tray: {
                create: 'https://d8c211c4-49af-4009-9c67-1e6bcf8d6560.trayapp.io',
            },
            /** get new integration session token, for a given login access token and group IDs*/
            session: 'https://e930ceb5-b729-46ee-aa09-b3b6d04005f1.trayapp.io'
        }
    }

    if (getRunEnv() !== "production") {
        urls.integrations.listAll = 'https://integration-helpers-git-refs-headsdev-vromo-integrations.vercel.app/api/v2/integrations'
        // urls.integrations.listAll = 'http://localhost:3001/api/v2/integrations'
    }

    return urls
}

export const mapboxStyles = {
    dark: 'mapbox://styles/fleeteng/cjqxocjah1u7n2srsctxdl5kr',
    light: 'mapbox://styles/fleeteng/cjqxob8rr0qoh2spb76mhzm9t',
}

export const httpProtocol = process.env.DONT_USE_SSL ? 'http' : 'https';

export const wsProtocol = process.env.DONT_USE_SSL ? 'ws' : 'wss';

/** api access rights from highest to lowest privileges */
export const UserAccessOrder = [
    'admin',
    'freemiumAdmin',
    'user',
    'freemiumUser',
    'client'
] as const;
/** api access rights types */
export type UserAccessTypes = typeof UserAccessOrder[number];

/** BE defined ids for different types of user */
export const UserAccessPosition: { [K in UserAccessTypes]: number } = {
    admin: 4131741698,
    freemiumAdmin: 6436765697,
    user: 4131741697,
    freemiumUser: 169050153926666,
    client: 4235444225
};

export const zapierSignupSurveyUrl = 'https://hooks.zapier.com/hooks/catch/1689202/7qmp7n';
